import React from "react"

export default function WhatsappRedeemLink() {
  const contactWhatsApp = {
    "es-CO": { num: "573208576801", label: "320 857 6801" },
    "es-EC": { num: "593987460088", label: "+593 98 746 0088" },
  }[process.env.LOCALE]

  return (
    <>
      {(contactWhatsApp && (
        <a
          href={`https://wa.me/${contactWhatsApp.num}?text=Hola%20NosotrasOnline.`}
        >
          {contactWhatsApp.label}
        </a>
      )) || <a href="#">--- --- ----</a>}
    </>
  )
}
